import { breakpoints, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const FieldWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.sm')};
  width: 100%;

  &:empty {
    display: none;
  }
`;
export const ContainerDivider = styled.div `
  margin-top: ${themeGet('spacing.2xl')};
  border-top: solid ${pxToRem(1)} ${themeGet('colors.gray.100')};
`;
export const ColumnsContainer = styled.div `
  display: flex;
  gap: ${themeGet('spacing.xl')};

  ${breakpoints.xs} {
    flex-wrap: wrap;
  }
`;
export const LeftColumn = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${pxToRem(300)};

  ${breakpoints.xs} {
    flex: 1 1 auto;
  }
`;
export const RightColumn = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: ${themeGet('spacing.xl')};
`;
